import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { color } from '@nuvolo/nuux-theme/utils';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import { ReactComponent as NotFoundSvg } from '#/static/404.svg';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorPage from './ErrorPage';

const PageNotFound: React.FC = () => {
  const { isDesktop } = useViewport();
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/dashboard');
  };

  return (
    <NuvoBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      backgroundColor={color('primary', 'light2')}>
      <NuvoBox
        display="flex"
        width={isDesktop ? '33vw' : '90vw'}>
        <ErrorPage
          svg={NotFoundSvg}
          message="Page is not available."
          buttonLabel="Back"
          onButtonClick={handleBackClick}
          svgContainerStyle={isDesktop? undefined: { transform: 'scale(0.65)', transformOrigin: 'center' }}
        />
      </NuvoBox>
    </NuvoBox>
  );
};

export default React.memo(PageNotFound);
